import {BASE_URL} from "../../config/network";
import {ACCESSORIES_LOCATIONS_MOCK} from "../../mock/accessoriesMock";

const shouldFallbackToMock = ({status, error}) => {
    if (error && !status) return true;
    return [404, 405, 500, 501, 502, 503, 504].includes(Number(status));
};

const normalizeDistance = (value) => {
    if (value === null || value === undefined) return null;
    if (typeof value === "number") return value;
    if (typeof value === "string") {
        const normalized = Number(value.replace(",", "."));
        return Number.isFinite(normalized) ? normalized : null;
    }
    return null;
};

const normalizeLocationsPayload = (payload) => {
    const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.items)
            ? payload.items
            : Array.isArray(payload?.data)
                ? payload.data
                : [];

    return list.map((item, index) => ({
        id: item?.id ?? ACCESSORIES_LOCATIONS_MOCK[index]?.id ?? index + 1,
        name: item?.name || item?.title || "Onbekende locatie",
        latitude: item?.latitude ?? null,
        longitude: item?.longitude ?? null,
        distance_km: normalizeDistance(
            item?.distance_km ?? item?.distanceKm ?? item?.distance
        )
    }));
};

const buildMockLocations = () => {
    return ACCESSORIES_LOCATIONS_MOCK.map((location, index) => ({
        id: location.id || index + 1,
        name: location.name,
        latitude: location.latitude || null,
        longitude: location.longitude || null,
        distance_km: normalizeDistance(location.distance_km)
    }));
};

const searchAccessoriesLocationAPI = async ({lat, lng}) => {

    const URL = `${BASE_URL}/public/attributes/accessories/locations/search?lat=${lat}&lng=${lng}`
    const METHOD = "GET"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    try {
        const response = await fetch(URL, {
            method: METHOD,
            headers: HEADERS
        })

        if (!response.ok) {
            if (shouldFallbackToMock({status: response.status})) {
                return buildMockLocations()
            }
            throw new Error(`HTTP error: ${response.status}`)
        }

        const payload = await response.json()
        const normalized = normalizeLocationsPayload(payload)
        return normalized.length ? normalized : buildMockLocations()
    } catch (error) {
        if (shouldFallbackToMock({error})) {
            return buildMockLocations()
        }
        throw error
    }
}

export {searchAccessoriesLocationAPI}
